import React, { useState } from "react";
import { AiOutlineHome } from "react-icons/ai";
import { FaCartPlus, FaFileSignature, FaPage4, FaUsers } from "react-icons/fa";
import { FcWorkflow } from "react-icons/fc";
import { GrWorkshop } from "react-icons/gr";
import { IoIosArrowDown } from "react-icons/io";
import { MdDesignServices, MdKeyboardArrowUp } from "react-icons/md";
import { RiArticleLine, RiPriceTag2Fill } from "react-icons/ri";
import { SiGooglemessages } from "react-icons/si";
import { Link } from "react-router-dom";
const Sidebar = ({sidebarHide}) => {
   const [DasHide , setDasHide] =useState(false) 
  const [hide, setHide] = useState(true);
  const [BlogHide, SetBlogHide] = useState(true);
  const [PriceHide, SetPriceHide] = useState(true);
  const [UserHide, SetUserHide] = useState(true);
  const [MessageHide, SetMessageHide] = useState(true);
  const [orderHide, SetOrderHide] = useState(true);
  const [resumeHide , setResumeHide] =useState(true)
  const handleDash = () => {
    setDasHide(!DasHide)
  }
  const handleHide = () => {
    setHide(!hide);
  };
  const handleBlogHide = () => {
    SetBlogHide(!BlogHide);
  };
  const hanldeResume = () => {
    setResumeHide(!resumeHide);
  };
  const handlePriceHide = () => {
    SetPriceHide(!PriceHide);
  };
  const handleUserHide = () => {
    SetUserHide(!UserHide);
  };
  const handleMessageHide = () => {
    SetMessageHide(!MessageHide);
  };
  const handleOrderHide = () => {
    SetOrderHide(!orderHide,);
  };


  return (
    <div className={sidebarHide ? "sidebarHide" : "dashboard_sidebar_container"}>
      <div className="sidebar-items">
        <div className="sidebar-item">
          <div onClick={handleDash} className="page-name">
            <div>Dashboard</div>
          <div>{DasHide ? <IoIosArrowDown/> : <MdKeyboardArrowUp size={20}/> }</div>
          </div>

          <Link to="/admin/dashboard"className={DasHide ? "hide" : "item-flex default"}>
            <div>
              <AiOutlineHome />
            </div>
            <div className="text"> Home</div>
          </Link>

          <hr />
        </div>

        <div className="sidebar-item">
        <div onClick={handleHide} className="page-name">
            <div>Portfolio</div>
          <div>{hide ? <IoIosArrowDown/> : <MdKeyboardArrowUp size={20}/> }</div>
          </div>

          <Link  to="/admin/dashboard/all-portfolio"className={hide ? "hide" : "item-flex"}>
            <div>
              <FcWorkflow />
            </div>
            <div className="text">All portfolio</div>
          </Link>

          <Link to="/admin/dashboard/add-portfolio" className={hide ? "hide" : "item-flex"}>
            <div>
              <GrWorkshop />
            </div>
            <div className="text">Add Portfolio</div>
          </Link>

          <hr />
        </div>

        <div className="sidebar-item">
         
          <div onClick={handleBlogHide} className="page-name">
            <div> Blogs</div>
          <div>{BlogHide ? <IoIosArrowDown/> : <MdKeyboardArrowUp size={20}/> }</div>
          </div>


          <Link to="/admin/dashboard/all-blog" className={BlogHide ? "hide" : "item-flex"}>
            <div>
              <RiArticleLine />
            </div>
            <div className="text">All Blogs</div>
          </Link>

          <Link to="/admin/dashboard/add-blog" className={BlogHide ? "hide" : "item-flex"}>
            <div>
              <FaFileSignature />
            </div>
            <div className="text">Add Blog</div>
          </Link>

          <hr />
        </div>

        <div className="sidebar-item">
    
          <div onClick={handlePriceHide} className="page-name">
            <div>Pricing</div>
          <div>{PriceHide? <IoIosArrowDown/> : <MdKeyboardArrowUp size={20}/> }</div>
          </div>

          <Link to="/admin/dashboard/all-pricing" className={PriceHide ? "hide" : "item-flex"}>
            <div>
              <RiPriceTag2Fill />
            </div>
            <div className="text">All pricing</div>
          </Link>

          <Link to="/admin/dashboard/add-pricing" className={PriceHide ? "hide" : "item-flex"}>
            <div>
              <MdDesignServices />
            </div>
            <div className="text">Add pricing</div>
          </Link>

          <hr />
        </div>
        
        <div className="sidebar-item">
       
          <div onClick={handleOrderHide} className="page-name">
            <div> Order</div>
          <div>{orderHide? <IoIosArrowDown/> : <MdKeyboardArrowUp size={20}/> }</div>
          </div>

          <Link to="/admin/dashboard/all-orders" className={orderHide? "hide" : "item-flex"}>
            <div>
              <FaCartPlus />
            </div>
            <div className="text">All Orders</div>
          </Link>

          <hr />
          </div>
          <div className="sidebar-item">
       
       <div onClick={ hanldeResume} className="page-name">
         <div> Resume</div>
       <div>{resumeHide? <IoIosArrowDown/> : <MdKeyboardArrowUp size={20}/> }</div>
       </div>

       <Link to="/admin/dashboard/add-resume" className={resumeHide? "hide" : "item-flex"}>
         <div>
           <FaPage4 />
         </div>
         <div className="text">Add Resume</div>
       </Link>

       <hr />
       </div>

          

        <div className="sidebar-item">
       
          <div onClick={handleUserHide} className="page-name">
            <div> Users</div>
          <div>{UserHide? <IoIosArrowDown/> : <MdKeyboardArrowUp size={20}/> }</div>
          </div>

          <Link to="/admin/dashboard/all-users" className={UserHide ? "hide" : "item-flex"}>
            <div>
              <FaUsers />
            </div>
            <div className="text">All Users</div>
          </Link>

          <hr />
        </div>

        <div className="sidebar-item">
          <div onClick={handleMessageHide} className="page-name">
            <div>Messages</div>
          <div>{MessageHide? <IoIosArrowDown/> : <MdKeyboardArrowUp size={20}/> }</div>
          </div>
        

          <Link to="/admin/dashboard/all-messages" className={MessageHide ? "hide" : "item-flex"}>
            <div>
              <SiGooglemessages />
            </div>
            <div className="text">All Messages</div>
          </Link>

          <hr />
        </div>
 
      </div>
  
    </div>
  );
};

export default Sidebar;
